<template>
  <div class="risk-calculation">
    <div
      v-if="isNoResult"
      class="no-result-circle"
    >
      <i class="icon-help-filled no-result-circle_icon" />
      <p class="no-result-circle_text">
        {{ noResultText }}
      </p>
    </div>
    <LvTwistCircle
      v-else
      :icon="_resultRisk?_resultRisk.icon:''"
      :color="_resultRisk?_resultRisk.color:''"
      :title="_resultRisk?_resultRisk.title:''"
    />
    <div class="ques-number-list">
      <div class="list-item">
        <ChecklistAnswerTotalItem
          red
          title="紅地雷題"
          :total-number="_level12List?_level12List.length:0"
          :answer-number="_level12PassList?_level12PassList.length:0"
        />
      </div>
      <div class="list-item">
        <ChecklistAnswerTotalItem
          yellow
          title="黃地雷題"
          :total-number="_level11List?_level11List.length:0"
          :answer-number="_level11PassList?_level11PassList.length:0"
        />
      </div>
      <div class="list-item">
        <ChecklistAnswerTotalItem
          blue
          title="藍地雷題"
          :total-number="_level10List?_level10List.length:0"
          :answer-number="_level10PassList?_level10PassList.length:0"
        />
      </div>
    </div>
    <p class="risk-calculation_result">
      {{ resultTitle }} <span class="bold">{{ _passRate }}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "RiskCalculation",
  props: {
    answerList: {
      type: Object,
      default() {
        return {};
      },
    },
    isNoResult: {
      type: Boolean,
      default: false,
    },
    noResultText: {
      type: String,
      default: "尚無結果",
    },
    resultTitle: {
      type: String,
      default: "平均合規率",
    },
  },
  computed: {
    _level12List() {
      if (!this.answerList) return;
      return this.answerList.level12;
    },
    _level12PassList() {
      if (this._level12List.length === 0) {
        return this._level10List;
      }
      const passList = this.$_getPassListByScore(10, this._level12List);
      return passList;
    },
    _level11List() {
      if (!this.answerList) return;
      return this.answerList.level11;
    },
    _level11PassList() {
      if (this._level11List.length === 0) {
        return this._level10List;
      }
      const passList = this.$_getPassListByScore(10, this._level11List);
      return passList;
    },
    _level10List() {
      if (!this.answerList || this.answerList.level10 === undefined) return;
      return this.answerList.level10;
    },
    _level10PassList() {
      if (this._level10List.length === 0) {
        return this._level10List;
      }
      const passList = this.$_getPassListByScore(10, this._level10List);
      return passList;
    },
    _resultRisk() {
      let result = {};
      if (!this._level12List || !this._level11List || !this._level10List)
        return;
      if (
        !this._level12PassList ||
        !this._level11PassList ||
        !this._level10PassList
      )
        return;
      if (
        this._level12PassList.length < this._level12List.length ||
        this._level11PassList.length < this._level11List.length / 2
      ) {
        result.icon = "icon-risk-high-filled";
        result.color = "red";
        result.title = "高風險";
      } else if (
        this._level11PassList.length < this._level11List.length ||
        this._level10PassList.length < this._level10List.length / 2
      ) {
        result.icon = "icon-risk-medium-filled";
        result.color = "yellow";
        result.title = "中風險";
      } else if (this._level10PassList.length < this._level10List.length) {
        result.icon = "icon-risk-medium-filled";
        result.color = "blue";
        result.title = "低風險";
      } else {
        result.icon = "icon-approved-filled";
        result.color = "green";
        result.title = "合規";
      }
      return result;
    },
    _passRate() {
      if (this.isNoResult) {
        return "尚未計算";
      }
      const allLevelList = this._level12List.concat(
        this._level11List,
        this._level10List
      );
      const allPassRate = this.$_getPassRateByScore(allLevelList) * 10 + "%";
      return allPassRate;
    },
  },
  methods: {
    $_getPassListByScore(score, list) {
      if (!list || list.length === 0) return;
      const passList = list.filter((item) => item.score === score);
      return passList;
    },
    $_getPassRateByScore(list) {
      if (list.length === 0) return;
      const scoreArray = list.map((item) => item.score);
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      scoreArray.reduce(reducer);
      const result = scoreArray.reduce(reducer) / list.length;
      return result.toFixed(1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/risk-calucation";
</style>